export default __webpack_public_path__ + "static/10-most-instagrammable-places-on-earth-france-106064bbd3cbf43c0fc4f75c9db6c7b4.jpg";